import type { DataSubjectParams, OneTrustDataSubjectToken } from './types';

export type { DataSubjectParams, OneTrustDataSubjectToken };

/**
 * Gates both the logged-in opt-out toggle in the footers and cross-device consent sync, so they
 * flip together.
 */
export const ONETRUST_OPTOUT_LOGGED_IN_FLAG = 'onetrust_optout_logged_in' as const;

/** Maps the signed `{ identifier, token }` into the authenticated `dataSubjectParams` the SDK reads. */
export const buildDataSubjectParams = (token: OneTrustDataSubjectToken): DataSubjectParams => ({
  id: token.identifier,
  token: token.token,
  isAnonymous: false,
});
